var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin 1",
    clipPath: "url(#clip0_11_120)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.9971 11.8628V11.8624H10.9998V7.8281C10.9998 5.85452 10.575 4.33423 8.26771 4.33423C7.15854 4.33423 6.41421 4.9429 6.11033 5.51994H6.07825V4.51848H3.89062V11.8624H6.16854V8.22594C6.16854 7.26848 6.35004 6.34265 7.53575 6.34265C8.70404 6.34265 8.72146 7.43531 8.72146 8.28735V11.8628H10.9971Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.181641 4.51953H2.46231V11.8634H0.181641V4.51953Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.32092 0.863525C0.591708 0.863525 0 1.45523 0 2.18444C0 2.91365 0.591708 3.51773 1.32092 3.51773C2.05013 3.51773 2.64183 2.91365 2.64183 2.18444C2.64138 1.45523 2.04967 0.863525 1.32092 0.863525V0.863525Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(0 0.863525)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin1);
export default __webpack_public_path__ + "static/media/linkedin 1.d5f291af7a290d23b98da9a557d64b74.svg";
export { ForwardRef as ReactComponent };